/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Drastic_Tech_Stdout_LogInputs */

const en_drastic_tech_stdout_log = /** @type {(inputs: Drastic_Tech_Stdout_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC stdout]: ${i?.message}`)
};

const fr_drastic_tech_stdout_log = /** @type {(inputs: Drastic_Tech_Stdout_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC stdout] : ${i?.message}`)
};

const de_drastic_tech_stdout_log = /** @type {(inputs: Drastic_Tech_Stdout_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DROSTIC stdout]: ${i?.message}`)
};

const it_drastic_tech_stdout_log = /** @type {(inputs: Drastic_Tech_Stdout_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Stdout DRASTICO]: ${i?.message}`)
};

const ru_drastic_tech_stdout_log = /** @type {(inputs: Drastic_Tech_Stdout_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC stdout]: ${i?.message}`)
};

const es_drastic_tech_stdout_log = /** @type {(inputs: Drastic_Tech_Stdout_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Salida estándar DRASTIC]: ${i?.message}`)
};

const zh_cn2_drastic_tech_stdout_log = /** @type {(inputs: Drastic_Tech_Stdout_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC 标准输出]: ${i?.message}`)
};

const ja_drastic_tech_stdout_log = /** @type {(inputs: Drastic_Tech_Stdout_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC 標準出力]: ${i?.message}`)
};

const hi_drastic_tech_stdout_log = /** @type {(inputs: Drastic_Tech_Stdout_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC stdout]: ${i?.message}`)
};

const pt_pt2_drastic_tech_stdout_log = /** @type {(inputs: Drastic_Tech_Stdout_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Saída padrão DRASTIC]: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "[DRASTIC stdout]: {message}" |
*
* @param {Drastic_Tech_Stdout_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_stdout_log = /** @type {((inputs: Drastic_Tech_Stdout_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Stdout_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_stdout_log(inputs)
	if (locale === "de") return de_drastic_tech_stdout_log(inputs)
	if (locale === "it") return it_drastic_tech_stdout_log(inputs)
	if (locale === "ru") return ru_drastic_tech_stdout_log(inputs)
	if (locale === "es") return es_drastic_tech_stdout_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_stdout_log(inputs)
	if (locale === "ja") return ja_drastic_tech_stdout_log(inputs)
	if (locale === "hi") return hi_drastic_tech_stdout_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_stdout_log(inputs)
	return en_drastic_tech_stdout_log(inputs)
});